
import React, { Component, Fragment } from 'react';
import {   HashRouter as BrowserRouter, Route, Redirect } from 'react-router-dom';
import Header from './Header';
import Login from './Login';
import Logout from './Logout';
 import PostModal from './PostModal';
 import Home from './Home';
 import Spinner from './Spinner'
import { app } from '../config/base';
import SignUp from './SignUp';
function AuthenticatedRoute({component: Component, authenticated, ...rest}) {
  return (
    <Route
      {...rest}
      render={(props) => authenticated === true
        ? <Home {...props} {...rest} />
          : <Redirect to={{pathname: '/login', state: {from: props.location}}} /> } />
  )
}


class App extends Component {
  constructor() {
    super();
    this.setCurrentUser = this.setCurrentUser.bind(this);
    this.state = {
      authenticated: false,
      currentUser: null,
      loading: true
    };
  }



  setCurrentUser(user) {
    if (user) {
      this.setState({
        currentUser: user,
        authenticated: true
      })

    } else {
      this.setState({
        currentUser: null,
        authenticated: false
      })
    }
  }

  componentWillMount() {

    this.removeAuthListener = app.auth().onAuthStateChanged((user) => {
      if (user) {
        this.setState({
          authenticated: true,
          currentUser: user,
          loading: false,
        })

      } else {
        this.setState({
          authenticated: false,
          currentUser: null,
          loading: false,
        })

      }
    })
  }



  componentWillUnmount()
  {
    this.removeAuthListener();
  }

  render() {
    if (this.state.loading === true) {
      return (
        <div style={{ textAlign: "center", position: "absolute", paddingTop: "25%", paddingLeft: "50%", backgroundColor:"#1a2643", width:"100%", height:"100%" }}>
          <Spinner/>

        </div>
      )
    }

    return (
      <Fragment>
        <BrowserRouter>
          <div  className="container-fluid"  >

            <div className="container" >
              <div className="workspace">
                <Route exact path="/login" render={(props) => {
                  return <Login setCurrentUser={this.setCurrentUser} {...props} />
                }} />



                <Route exact path="/login" render={(props) => (
                  this.state.authenticated ? (
                    <Redirect push to="/signup"/>
                  ) : (
                    <Redirect push to="/login" />
                  )
                )}/>

                <Route exact path="/signup" component={SignUp} />
                <Route exact path="/logout" component={Logout} />

                <AuthenticatedRoute
                  exact
                  path="/"
                  authenticated={this.state.authenticated}
                  component={<Home/>}
                />


              </div>
            </div>
          </div>
        </BrowserRouter>
      </Fragment>

    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/components/App.js